import { ConfigProvider, App } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import React from 'react';

interface AntdConfigProviderProps {
  children: React.ReactNode
}

export const COLOR_PRIMARY = 'rgb(51 130 235)'; // #3382eb
export const COLOR_PRIMARY_HOVER = 'rgb(7,64,141)';

export default function AntdConfigProvider({ children }: AntdConfigProviderProps): React.ReactNode {
  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        token: {
          fontFamily: 'SF Pro Text',
          colorPrimary: COLOR_PRIMARY,
          colorLink: COLOR_PRIMARY,
          colorLinkHover: COLOR_PRIMARY_HOVER,
          colorLinkActive: COLOR_PRIMARY,
        },
      }}
    >
      <App>
        {children}
      </App>
    </ConfigProvider>
  );
}
